// removed by extract-text-webpack-plugin
module.exports = {"CustomObservationInfoTooltip":"CustomObservationInfoTooltip","customObservationInfoTooltip":"CustomObservationInfoTooltip","CustomObservationInfoTooltip__text":"CustomObservationInfoTooltip__text","customObservationInfoTooltipText":"CustomObservationInfoTooltip__text"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModerationCard/CustomObservationInfoTooltip.scss
// module id = 212
// module chunks = 0